// The ad attribution of a Studio sign-up (Meta Conversions API, contract 2.6.0). The click
// lands on `/studio?mode=…&utm_…&fbclid=…`, the visitor types the @ and signs in elsewhere,
// and the account is only created when they come back: so what the link carried is kept here
// on arrival and sent as `attribution` with POST /studio/creator and POST /studio/onboarding.
// Core qualifies the sign-up and sends CompleteRegistration from the server.
const KEY = 'ginastee:studio:attribution';
const PARAMS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'utm_id', 'ad_id', 'mode'];

const read = () => {
  try { return JSON.parse(window.localStorage.getItem(KEY) || '{}') || {}; } catch { return {}; }
};

const cookie = name => {
  const found = document.cookie.split('; ').find(item => item.startsWith(`${name}=`));
  if (!found) return undefined;
  try { return decodeURIComponent(found.slice(name.length + 1)); } catch { return undefined; }
};

const defined = object => Object.fromEntries(Object.entries(object).filter(([, value]) => value !== undefined && value !== null && value !== ''));

// Each arrival refreshes what its link carried and keeps the rest; a new click (fbclid) also
// moves the landing URL and time. A visit whose link carries nothing changes nothing once
// something is kept.
export function captureAttribution(href = window.location.href) {
  let url;
  try { url = new URL(href); } catch { return; }
  const params = url.searchParams;
  const previous = read();
  const fbclid = params.get('fbclid');
  const carried = !!fbclid || PARAMS.some(key => params.get(key));
  if (!carried && Object.keys(previous).length) return;

  const now = Date.now();
  const next = { ...previous };
  PARAMS.forEach(key => { if (params.get(key)) next[key] = params.get(key); });
  if (fbclid) {
    Object.assign(next, { fbclid, fbc_from_click: `fb.1.${now}.${fbclid}`, landing_url: url.toString(), landing_at: now });
  } else {
    if (!next.landing_url) next.landing_url = url.toString();
    if (!next.landing_at) next.landing_at = now;
  }
  try { window.localStorage.setItem(KEY, JSON.stringify(defined(next))); } catch { /* Sent without it. */ }
}

// The landing's niche, as the link named it (`mode`), for the pixel's events.
export const attributionMode = () => read().mode;

// The body's `attribution`: what was kept plus the pixel's own cookies (`_fbp`, and `_fbc`
// once the pixel saw the click; the one built from the click stands in until then).
export function attributionPayload() {
  const kept = read();
  return defined({
    ...kept,
    fbp: cookie('_fbp'),
    fbc: cookie('_fbc') ?? kept.fbc_from_click,
    event_source_url: kept.landing_url ?? window.location.href,
  });
}
